<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section aria-labelledby="ack" epub:type="acknowledgments" role="doc-acknowledgments">
<header>
<h1 class="FM-Head-fmh"><span aria-label="ix" id="pg_ix" role="doc-pagebreak"><span href="#/xhtml/contents#c_ack" id="ack" title="Link target outside of Sample"><i>Acknowledgements</i></span></span></h1>
</header>
<p class="FM-Text-No-Indent-fmtx1">Of all those who have helped me during the writing of this book, I would particularly like to thank Julian Warren for his technical assistance. I would also like to thank Susan Watt for making editing such a painless process.</p>
<p class="FM-Text-fmtx">I am especially indebted to Toby Eady for reasons too numerous to list here. Suffice to say that I regard this book as something of a joint venture.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?0acb5813